import script from "./imgListDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./imgListDialog.vue?vue&type=script&setup=true&lang=js"

import "./imgListDialog.vue?vue&type=style&index=0&id=27d997e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d997e1"]])

export default __exports__